/*!

=========================================================
* Vue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import store from './store';
import authReady, { initAuthReady } from './authReady'
import dateTimeFilter from './filters/dateTime'
import elasticsearchDate from './filters/elasticsearchDate'
import dateAndTimeFilter from './filters/dateAndTime'
import dateTimeArchiveAssociationFilter from './filters/dateTimeArchiveAssociation'
import dateFilter from './filters/date'
import fileSizeFilter from './filters/fileSize'
import durationFilter from './filters/duration'

// router setup
import router from './routes/router';
// plugin setup
Vue.use(DashboardPlugin);

Vue.filter('elasticsearchDate', elasticsearchDate)
Vue.filter('dateTime', dateTimeFilter)
Vue.filter('dateAndTime', dateAndTimeFilter)
Vue.filter('dateTimeArchiveAssociation', dateTimeArchiveAssociationFilter)
Vue.filter('fileSize', fileSizeFilter)
Vue.filter('duration', durationFilter)
Vue.filter('date', dateFilter)

// import { createPinia, PiniaVuePlugin } from 'pinia'
// // import {commonPlugin} from './stores/plugins/baseStorePlugin';


// Vue.use(PiniaVuePlugin)
// const pinia = createPinia()
// // pinia.use(commonPlugin)


import VueVideoPlayer from 'vue-video-player'

// require videojs style
import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'

Vue.use(VueVideoPlayer, /* {
  options: global default options,
  events: global videojs events
} */)

//componenets
import VueMasonry from 'vue-masonry-css'
Vue.use(VueMasonry);

import {
  Select,
  Option,
  OptionGroup,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Table,
  TableColumn
} from "element-ui";
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Tooltip)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Table)
Vue.use(TableColumn)

import Loader from '@/echoComponents/LoadingSpinner'
Vue.component('loading-spinner', Loader)
import FilePreview from '@/echoComponents/FilePreview'
Vue.component('file-preview', FilePreview)

/* eslint-disable no-new */

initAuthReady(store)

authReady.finally(() => {
  new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store,
    // pinia,
  });
})


// import {
//   onAuthStateChanged,
// } from "firebase/auth";
// import { auth, db } from "./firebase";
// import { doc, getDoc} from "firebase/firestore"; 

// import { useUserStore } from './stores/user'

// let app
// onAuthStateChanged(auth, async (user) => {
//     if (!app) {
//     app = new Vue({
//       el: '#app',
//       render: h => h(App),
//       router,
//       store,
//       pinia,
//       async created() {

//     const userStore = useUserStore()

//     if (user) {
//         // User is signed in, see docs for a list of available properties
//         // https://firebase.google.com/docs/reference/js/auth.user

//         userStore.uid = user.uid
//         const docRef = doc(db, "users", user.uid);
//         const docSnap = await getDoc(docRef);
        
//         if (docSnap.exists()) {
//             const userData = docSnap.data()
//             userStore.userData = userData
//             console.log(userStore.userData)
//             // for (const [key, value] of Object.entries(userData.workspaces)) {
//             //     if(value) {
//             //         const workspaceRef = doc(db, "workspaces", key)
//             //         const docSnap = await getDoc(workspaceRef);
//             //         console.log(docSnap.data())
//             //     }
//             //   }
              
            
//         } else {
//           // docSnap.data() will be undefined in this case
//           console.log("No such document!");
//         }
        
        
//     } else {
//         userStore.userData = false;
//     }
//   }
// })
//     }
//     })
